export const FAVORITES_ROOT_PARENT_PATH = '/Root/Content'
export const FAVORITES_ROOT_NAME = '(favorites)'
export const FAVORITES_ROOT_DISPLAY_NAME = 'Favorites'
export const FAVORITES_ROOT_PATH = `${FAVORITES_ROOT_PARENT_PATH}/${FAVORITES_ROOT_NAME}`
export const FAVORITE_LINK_NAME_PREFIX = 'favorite-'
